import { useTheme } from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CloseIcon = ({
  title
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs("svg", {
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("title", {
      children: title
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.5,1.5l-13,13m0-13,13,13",
      transform: "translate(-1 -1)",
      fill: theme.color['icon-core-subtle'],
      stroke: theme.color['icon-core-subtle'],
      strokeWidth: "2"
    })]
  });
};
export default CloseIcon;